import { Modal } from "antd";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import ModalHeaderText from "../../common/ModalHeaders/ModalHeaderText";
import { Form, Button, message, notification } from "antd";
import { saveResendLinkEmployeeDetails } from "../../redux/ResentMailAddEmployee/action";
import useSession from "../CustomLogout/useSession";
const ResendPartnerWelcomeMail = ({ drawerOpen, setDrawerOpen, ...props }) => {
  const handleSessionExpired = useSession();

  const [form] = Form.useForm();

  const handleCancel = () => {
    setDrawerOpen(false);
    form.resetFields();
  };

  const signatoryEmail = props.row?.original?.emailAddress;

  const handleResendEmailLink = () => {
    props
      .saveResendLinkEmployeeDetails({
        access_token: props.access_token,
        userId: props.row?.original?.userId,
      })
      .then((res) => {
        if (res && res.status === 200) {
          message.success("Resent Welcome Mail link resend successfully");

          setDrawerOpen(false);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  return (
    <div>
      <Modal
        open={drawerOpen}
        closable={false}
        className="modal-container"
        centered
        footer={null}
      >
        <Form
          autoComplete="off"
          name="resendRegistration"
          layout="vertical"
          form={form}
          onFinish={handleResendEmailLink}
        >
          <Row>
            <Col lg={12} xs={12} md={12} sm={12}>
              <Col md={12} className="headre-login">
                <ModalHeaderText LoginHeading="Resend Welcome Mail" />
              </Col>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col lg={12} xs={12} md={12} sm={12}>
              <p>
                The link will be resent to the Partner Signatory user on the
                following:{" "}
              </p>
            </Col>
          </Row>
          <Row>
            <Col lg={12} xs={12} md={12} sm={12}>
              <p className="color-blue">
                {">"} {signatoryEmail}
              </p>
            </Col>
          </Row>
          <Row className="">
            <Col md={12} className="d-flex justify-content-end">
              <Button
                className="mr-3"
                htmlType="button"
                type="default"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
              <Button className="" htmlType="submit" type="primary">
                CONFIRM
              </Button>
            </Col>
          </Row>
        </Form>{" "}
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveResendLinkEmployeeDetails: (data) =>
      dispatch(saveResendLinkEmployeeDetails(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResendPartnerWelcomeMail);
